import { Socket } from 'socket.io-client';
import { create } from 'zustand';

type SocketStoreState = {
  setSocket: (socket: Socket | null) => void;
  socket: Socket | null;
};

export const useSocketStore = create<SocketStoreState>(set => ({
  setSocket: socket => set({ socket }),
  socket: null,
}));
